import { date, object, string, boolean } from "yup";
import { REQUIRED_FIELD } from "@shared-kernel/primary/forms/constants";
import { getMinFiscalPeriodDate } from "@shared-kernel/primary/shared/date/min-fiscal-period-date";
import type { RequestTeacherPayoutBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export interface PayoutRequestFormInputs {
  invoiceNumber: string;
  invoiceUrl: string;
  invoiceDate: Date;
  invoiceDeadline: Date;
  isConfirmed: boolean;
}

// invoiceDate and invoiceDeadline are not included in defaultValues because they are set relative to now when the form is initialized
export const defaultPayoutRequestValues: Omit<PayoutRequestFormInputs, "invoiceDate" | "invoiceDeadline"> = {
  invoiceNumber: "",
  invoiceUrl: "",
  isConfirmed: false,
};

export const createPayoutRequestSchema = (now: Date) =>
  object().shape({
    invoiceNumber: string().required(REQUIRED_FIELD).max(100, "Maximum 100 caractères"),
    invoiceUrl: string().required("Veuillez télécharger une facture"),
    invoiceDate: date()
      .required(REQUIRED_FIELD)
      .min(getMinFiscalPeriodDate(now), "La date ne peut pas être antérieure à la période autorisée")
      .max(now, "La date de facturation ne peut pas être dans le futur"),
    invoiceDeadline: date()
      .required(REQUIRED_FIELD)
      .test("after-invoice-date", "La date d'échéance doit être postérieure à la date de facturation", function (value) {
        const { invoiceDate } = this.parent;
        if (!invoiceDate || !value) return true;
        return value.getTime() > invoiceDate.getTime();
      }),
    isConfirmed: boolean().oneOf([true], "Vous devez confirmer le montant").required(REQUIRED_FIELD),
  });

export const formatFormDataToBody = (formData: PayoutRequestFormInputs): RequestTeacherPayoutBody => {
  return {
    invoice: {
      url: formData.invoiceUrl,
      number: formData.invoiceNumber,
      date: formData.invoiceDate.toISOString(),
      deadline: formData.invoiceDeadline.toISOString(),
    },
  };
};
